import React from 'react'
import { CancellationState } from '@core/Areas/Account/Pages/Activity/types'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { NoticeBox } from '@core/Components/NoticeBox'
import { queryClient } from '@core/Data/ReactQuery'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { CompletedWithdrawalDetailsStyled } from './CompletedWithdrawalDetails.styles'

export const CompletedWithdrawalDetails: React.FC<{
  cancellationState: CancellationState
  setCancellationState: React.Dispatch<React.SetStateAction<CancellationState>>
  selectedDate: string
}> = ({ cancellationState, setCancellationState, selectedDate }) => {
  const isSuccessfullyCompleted = cancellationState === 'completed'
  const message = isSuccessfullyCompleted
    ? 'Cancellation was successful. Your balance has been updated.'
    : 'Your transaction could not be cancelled.'

  const clearTransactionsCache = () => {
    queryClient.invalidateQueries({
      queryKey: queryKeys.accountActivityData('transactions', false, selectedDate),
    })

    if (!isSuccessfullyCompleted) {
      setCancellationState('initial')
    }
  }

  return (
    <CompletedWithdrawalDetailsStyled data-testid='transaction-completed-withdrawal'>
      <div>
        <NoticeBox title={message} noticeBoxType={isSuccessfullyCompleted ? 'Success' : 'Error'} />
      </div>
      <div>
        <ButtonBlock data-tid-close-button onClick={clearTransactionsCache}>
          Close
        </ButtonBlock>
      </div>
    </CompletedWithdrawalDetailsStyled>
  )
}
